import { useUserContext } from '@contexts/user'
import { convertToISO8601, formatDateUTCToDisplay } from '@helpers/date'

export const CreatedAt = ({ createdAt }: { createdAt: string }) => {
  const { timezone } = useUserContext()

  const formattedCreatedAt = formatDateUTCToDisplay(
    convertToISO8601(createdAt),
    {
      withTime: true,
      timezone
    }
  )

  return <div>{formattedCreatedAt}</div>
}
